module.exports = __webpack_public_path__ + "img/tebelopele_logo.dc27feae.png";